import SearchableSelectableTable from './searchabletable';
import client from '../../../../../API';

const cols = [
  { key: 'email',        label: 'Email' },
  { key: 'company_name', label: 'Company' },
  { key: 'fullName',     label: 'Full Name', render: (r) => `${r.first_name} ${r.last_name}` },
];

export default function ActiveUsersTable(props) {
  return (
    <SearchableSelectableTable
      queryFn={client.users.userList}
      rowsData={props.rowsData}
      loading={props.loading}
      columns={cols}
      {...props}
    />
  );
}
